import React from 'react';
import './Passkey.css';

export const PasskeyPersonKeyIcon = ({ className = '' }) => (
    <svg
        aria-hidden="true"
        className={className}
        fill="currentColor"
        focusable="false"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M11 12q-1.65 0-2.825-1.175Q7 9.65 7 8q0-1.65 1.175-2.825Q9.35 4 11 4q1.65 0 2.825 1.175Q15 6.35 15 8q0 1.65-1.175 2.825Q12.65 12 11 12Zm0-2q.825 0 1.413-.588Q13 8.825 13 8t-.587-1.412Q11.825 6 11 6q-.825 0-1.412.588Q9 7.175 9 8t.588 1.412Q10.175 10 11 10ZM3 20v-2.775q0-.85.425-1.575t1.175-1.1q1.275-.65 2.887-1.1Q9.1 13 11 13q.525 0 1.025.037.5.038 1 .113.025.575.15 1.1.125.525.4 1.025-.575-.125-1.225-.2Q11.7 15 11 15q-1.8 0-3.2.438-1.4.437-2.3.887-.25.125-.375.375T5 17.225V18h10v2Zm15.25 1L17 19.5v-3.675q-.875-.325-1.438-1.087Q15 13.975 15 13q0-1.25.875-2.125T18 10q1.25 0 2.125.875T21 13q0 .975-.562 1.738-.563.762-1.438 1.087L20 17l-1 1 1 1ZM18 14.5q.625 0 1.062-.438.438-.437.438-1.062t-.438-1.062Q18.625 11.5 18 11.5t-1.062.438Q16.5 12.375 16.5 13t.438 1.062q.437.438 1.062.438ZM11 8h-.012H11Zm0 7Z" />
    </svg>
);

const PasskeyLoginButton = ({
    onClick,
    disabled = false,
    busy = false,
    supported = true,
    supportMessage = '',
}) => {
    if (!supported && supportMessage) {
        return <p className="passkey-login-hint">{supportMessage}</p>;
    }

    // return (
    //     <div className="passkey-login">
    //         <div className="passkey-divider" aria-hidden="true">or</div>
    //         <button
    //             type="button"
    //             className="passkey-login-btn"
    //             onClick={onClick}
    //             disabled={disabled || busy || !supported}
    //         >
    //             <PasskeyPersonKeyIcon className="passkey-login-btn__icon" />
    //             <span className="passkey-login-btn__text">
    //                 {busy ? 'Waiting for passkey…' : 'Use your passkey'}
    //             </span>
    //         </button>
    //     </div>
    // );
};

export default PasskeyLoginButton;
